// Pure helpers for the Users screen: a display label for a user and a
// case-insensitive search predicate over name + email. Kept side-effect free so
// the list filtering is unit-tested without rendering.

import type { UserDto } from "../api/types.js"

/** Full name ("First Last"), trimmed; falls back to the email when both are blank. */
export function userFullName(user: UserDto): string {
  const name = `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim()
  return name || user.email
}

/** Match a user against a free-text query (name or email, accent-insensitive-ish). */
export function userMatches(user: UserDto, query: string): boolean {
  const q = query.trim().toLowerCase()
  if (!q) return true
  const haystack = `${userFullName(user)} ${user.email}`.toLowerCase()
  return haystack.includes(q)
}

/** Filter + stable A→Z sort (by full name) for a deterministic list. */
export function filterUsers(users: UserDto[], query: string): UserDto[] {
  return users
    .filter((u) => userMatches(u, query))
    .sort((a, b) => userFullName(a).localeCompare(userFullName(b)))
}
